module.exports = __webpack_public_path__ + "img/SKLB-Updates.3e58cf5c.png";